module.exports = __webpack_public_path__ + "img/agreement.3d0f46e3.png";